// plugins/notifications.client.ts

import Notifications from "@kyvg/vue3-notification";
import { defineNuxtPlugin } from "#app";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(Notifications);
});
